import moment from 'moment';
import React from 'react';
// Pre-Conference Webinar Announcement
const SixteenStepTemplate = ({ values }) => {
  const {
    client_name,
    speaker_name,
    webinar_date_time,
    relevent_field_topic,
    conference_name,
    registration_link,
  } = values;

  return (
    <div>
      <p>{client_name ? `Hi ${client_name},` : `Hi [Recipient's Name],`}</p>
      <p>
        We’re excited to announce that <strong>IFERP</strong> is hosting an
        exclusive
        <strong>pre-conference webinar</strong> with{' '}
        <strong>{speaker_name ? speaker_name : `[Speaker's Name]`}</strong> on{' '}
        <strong>
          {webinar_date_time
            ? moment(webinar_date_time).format('YYYY-MM-DD [at] HH:mm')
            : '[Date and Time Range for Registration]'}
        </strong>
        .
      </p>

      <p>
        This webinar will provide early insights into{' '}
        {relevent_field_topic ? relevent_field_topic : `[Relevant Field/Topic]`}{' '}
        and feature an <strong>interactive Q&A session</strong> where you can
        get your questions answered directly by the expert.
      </p>

      <p>
        <strong>As a bonus, all webinar participants will receive:</strong>
        <br />✅ A <strong>free certificate of participation</strong>
        <br />✅ A <strong>10% discount</strong> on the conference registration
        fee
      </p>
      <p>
        This is a fantastic opportunity to enhance your knowledge and get a head
        start on the discussions at{' '}
        <strong>
          {conference_name ? conference_name : `[Conference Name]`}
        </strong>
        .
      </p>

      <p>
        {registration_link ? (
          <>
            <strong>👉 Register Now: </strong>
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here
            </a>
          </>
        ) : (
          <strong>👉 Register Now: [Registration Link]</strong>
        )}
      </p>

      <p>
        Don’t miss out on this valuable session. We look forward to seeing you
        there!
      </p>
    </div>
  );
};

export default SixteenStepTemplate;
